// @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)

// @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })
import * as accessibility from './accessibility';
import * as api from './api';
import * as app from './app';
import * as appsInitialize from './appsInitialize';
import * as authentication from './authentication';
import * as common from './common';
import * as componentStyle from './componentStyle';
import * as configuration from './configuration';
import * as context from './context';
import * as csv from './csv';
import * as data from './data';
import * as disclaimers from './disclaimers';
import * as dxm from './dxm';
import * as eventBus from './eventBus';
import * as events from './events';
import * as helpers from './helpers';
import * as layout from './layout';
import * as learning from './learning';
import * as portal from './portal';
import * as query from './query';
import * as studio from './studio';
import * as utils from './utils';
// @endindex
export {
	// @index('./*', pp => `${pp.name},`, { "ignore": ["./*.md"] })
	accessibility,
	api,
	app,
	appsInitialize,
	authentication,
	common,
	componentStyle,
	configuration,
	context,
	csv,
	data,
	disclaimers,
	dxm,
	eventBus,
	events,
	helpers,
	layout,
	learning,
	portal,
	query,
	studio,
	utils,
	// @endindex
};